import React, { useEffect, useState } from 'react';
import './NavBar.css';
import {
  Collapse,
  Nav,
  NavItem,
  Navbar,
  NavbarToggler,
} from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import BaseUrl from '../../base-api';

const NavBar = () => {
  const navigate = useNavigate();
  const [links, setLinks] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  const linkPath = {
    "dashboard": "/SideBar/dashboard",
    "applications": "/SideBar/applications",
    "admissionForm": "/SideBar/registration-details",
    "courses": "/SideBar/my-courses",
    "learnerDetails": "/SideBar/learner-details",
    "session": "/SideBar/SessionDetails",
    "admissions": "/SideBar/admissions",
    "new-admission": "/SideBar/new-admission",
    "training": "/SideBar/training-partner",
  };

  useEffect(() => {
    axios.get(`${BaseUrl}/auth/privileges`, {
      headers: {
        Authorization: localStorage.getItem("$3ingT0k3n"),
      },
    }).then(response => {
      const updatedLinks = response.data.map((item) => {
        const path = linkPath[item.key];
        return path ? { ...item, to: path } : null;
      }).filter(Boolean);
      setLinks(updatedLinks);
    });

  }, []);

  const toggle = () => setCollapsed(!collapsed);

  const logout = () => {
    localStorage.removeItem("$3ingT0k3n");
    navigate("/");
    toast.success("Successfully logout");
  };

  const handleNavItemClick = () => {
    if (window.innerWidth <= 768) {
      setCollapsed(true);
    }
  };

  return (
    <Navbar expand="md" style={{ position: 'sticky', top: 150 }}>
      <NavbarToggler onClick={toggle} />
      <Collapse isOpen={!collapsed} navbar>
        <Nav vertical className="w-100 text-center">
          {links.map((link, index) => (
            <NavItem
              key={index}
              className="p-2 mt-2"
              style={{ backgroundColor: "#bbe5ff" }}
              onClick={handleNavItemClick}
            >
              <Link
                className="list-group-item list-group-item-action"
                to={link.to}
              >
                {link.label}
              </Link>
            </NavItem>
          ))}
          <NavItem
            className="p-2 mt-2"
            style={{ backgroundColor: "#bbe5ff" }}
            onClick={handleNavItemClick}
          >
            <Link
              className="list-group-item list-group-item-action"
              to="/"
              onClick={logout}
            >
              Logout
            </Link>
          </NavItem>
        </Nav>
      </Collapse>
    </Navbar>
  );
};

export default NavBar;
